(function(){
  function fix(root){
    (root||document).querySelectorAll('.product-count__text, #ProductCount, #ProductCountDesktop, .facets__product-count').forEach(function(el){
      var t=el.textContent;
      var n=t.replace(/\bproducts\b/g,'dresses').replace(/\bproduct\b/g,'dress');
      if(n!==t) el.textContent=n;
    });
    (root||document).querySelectorAll('.aetr__badges span:not(.aetr__stars)').forEach(function(el){
      if(el.textContent.indexOf('London to California')>-1) el.textContent='Brides from England to Japan, Hawaii to Australia';
    });
  }
  function menus(){
    /* Desktop: hover opens the dropdown, click on the word goes to the page */
    var canHover=window.matchMedia('(hover:hover) and (pointer:fine)').matches;
    document.querySelectorAll('details.aet-hover').forEach(function(d){
      var t;
      if(canHover){
        d.addEventListener('mouseenter',function(){clearTimeout(t);d.setAttribute('open','');d.querySelector('summary').setAttribute('aria-expanded','true');});
        d.addEventListener('mouseleave',function(){t=setTimeout(function(){d.removeAttribute('open');d.querySelector('summary').setAttribute('aria-expanded','false');},150);});
      }
      var a=d.querySelector('.aet-toplink');
      if(a) a.addEventListener('click',function(e){e.stopPropagation();});
    });
    /* Mobile drawer: add the parent page as the first link in each submenu */
    document.querySelectorAll('summary[data-href]').forEach(function(s){
      var h=s.id.replace('HeaderMenu-','');
      var ds=document.getElementById('HeaderDrawer-'+h);
      if(!ds) return;
      var ul=ds.parentNode.querySelector('.menu-drawer__submenu ul.menu-drawer__menu');
      if(!ul||ul.querySelector('.aet-overview')) return;
      var li=document.createElement('li');
      var a=document.createElement('a');
      a.href=s.getAttribute('data-href');
      a.className='menu-drawer__menu-item link link--text list-menu__item focus-inset aet-overview';
      a.textContent='All '+(s.textContent||'').trim().toLowerCase();
      li.appendChild(a);ul.insertBefore(li,ul.firstChild);
    });
  }
  function policies(){
    if(!/\/policies\/(shipping|refund)-policy/.test(location.pathname))return;
    /* Policy pages: the first line of each paragraph (before a line break) is a heading */
    document.querySelectorAll('.shopify-policy__body p').forEach(function(p){
      if(p.querySelector('.aet-ph'))return;
      var br=p.querySelector('br'); if(!br)return;
      var s=document.createElement('span'); s.className='aet-ph';
      while(p.firstChild&&p.firstChild!==br){s.appendChild(p.firstChild);}
      if(!s.textContent.trim()||s.textContent.length>80){while(s.firstChild){p.insertBefore(s.firstChild,br);}return;}
      p.insertBefore(s,br); br.remove();
    });
  }
  function noBest(){document.querySelectorAll('select[name="sort_by"] option[value="best-selling"]').forEach(function(o){if(!o.selected)o.remove();});}
  document.addEventListener('DOMContentLoaded',function(){
    fix();menus();policies();noBest();
    new MutationObserver(function(){fix();noBest();}).observe(document.body,{childList:true,subtree:true});
  });
})();
